<div class="mx-auto w-full max-w-5xl space-y-6 p-6">
  <div class="rounded-xl border border-gray-200 bg-white p-6">
    <div class="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div class="space-y-2">
        <h2 class="text-lg font-semibold text-gray-900">Inscripción corporativa · Plan individual</h2>
        <p class="text-sm text-gray-500">Gestione las cuotas asignadas a <span class="font-medium text-gray-900">{{ participantInfo?.name }}</span> dentro del acuerdo corporativo.</p>
      </div>
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        <div class="flex items-center gap-2 text-gray-700">
          <span class="font-medium text-gray-900">Empresa</span>
          <span>{{ corporateInfo?.companyName }}</span>
        </div>
        <div class="mt-1 flex items-center gap-2">
          <span class="text-gray-500">Proyecto</span>
          <span class="font-medium text-gray-800">{{ corporateInfo?.projectName }}</span>
        </div>
        <div class="mt-1 flex items-center gap-2 text-xs text-gray-500">
          <span>NIT {{ corporateInfo?.companyNIT }}</span>
          <span>· Acuerdo #{{ corporateInfo?.agreementId }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-xl border border-gray-200 bg-white p-6">
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 class="text-2xl font-semibold text-gray-900">Plan de pagos del participante</h1>
        <p class="text-sm text-gray-500">Configure o ajuste las cuotas individuales pendientes.</p>
      </div>
      <div class="flex items-center gap-3">
        <button type="button" (click)="volverAInscripcion()"
                class="inline-flex items-center gap-1.5 text-sm text-gray-700 border border-gray-200 px-3 py-1.5 rounded-md hover:bg-gray-50">
          ← Volver a la inscripción
        </button>
        <button type="button"
                (click)="openRefinanceModal()"
                [disabled]="remainingBalance <= 0"
                class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"></path>
          </svg>
          Refinanciar cuotas
        </button>
      </div>
    </div>
  </div>

  <div class="rounded-xl border border-gray-200 bg-white p-6">
    <span class="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">Resumen</span>
    <div class="mt-4 grid gap-4 md:grid-cols-3">
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Total del participante</p>
        <p class="mt-2 text-lg font-semibold text-gray-900">{{ totalAmount | currency:'COP' }}</p>
        <p *ngIf="getParticipantUnassigned() > 0" class="text-xs font-semibold text-amber-700 mt-1">
          Faltante por reasignar: {{ getParticipantUnassigned() | currency:'COP':'symbol':'1.0-2' }}
        </p>
      </div>
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Total pagado</p>
        <p class="mt-2 text-lg font-semibold text-gray-900">{{ amountPaid | currency:'COP' }}</p>
      </div>
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Saldo restante</p>
        <p class="mt-2 text-lg font-semibold text-gray-900">{{ remainingBalance | currency:'COP' }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="exceedsTotalAmount" class="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">
    <div class="flex items-start gap-3">
      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-rose-100 text-rose-600">
        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
        </svg>
      </div>
      <div class="space-y-1">
        <h3 class="font-semibold text-rose-900">El total asignado supera el límite</h3>
        <p>El total asignado en cuotas ({{ totalAssignedAmount | currency:'COP' }}) supera el saldo restante ({{ remainingBalance | currency:'COP' }}).</p>
      </div>
    </div>
  </div>

  <div *ngIf="!isExactMatch && !exceedsTotalAmount" class="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-700">
    <div class="flex items-start gap-3">
      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-amber-100 text-amber-600">
        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
        </svg>
      </div>
      <div class="space-y-1">
        <h3 class="font-semibold text-amber-900">Distribución pendiente</h3>
        <p>El total asignado en cuotas ({{ totalAssignedAmount | currency:'COP' }}) debe ser igual al saldo pendiente ({{ remainingBalance | currency:'COP' }}).</p>
      </div>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="space-y-6">
    <div class="rounded-xl border border-gray-200 bg-white p-6">
      <div class="space-y-1">
        <span class="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">Control</span>
        <h3 class="text-base font-semibold text-gray-900">Distribución del plan del participante</h3>
      </div>

      <div class="mt-4 grid gap-4 md:grid-cols-3">
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Saldo a distribuir</p>
          <p class="mt-2 text-lg font-semibold text-gray-900">{{ remainingBalance | currency:'COP' }}</p>
        </div>
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Total asignado</p>
          <p class="mt-2 text-lg font-semibold"
             [ngClass]="{
               'text-emerald-600': totalAssignedAmount <= remainingBalance,
               'text-rose-600': totalAssignedAmount > remainingBalance
             }">
            {{ totalAssignedAmount | currency:'COP' }}
          </p>
        </div>
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Diferencia</p>
          <p class="mt-2 text-lg font-semibold"
             [ngClass]="{
               'text-gray-900': (remainingBalance - totalAssignedAmount) === 0,
               'text-amber-600': (remainingBalance - totalAssignedAmount) > 0,
               'text-rose-600': (remainingBalance - totalAssignedAmount) < 0
             }">
            {{ (remainingBalance - totalAssignedAmount) | currency:'COP' }}
          </p>
          <span class="mt-1 block text-xs text-gray-500">
            {{ (remainingBalance - totalAssignedAmount) === 0 ? 'Distribución completa' :
               (remainingBalance - totalAssignedAmount) > 0 ? 'Restante por asignar' :
               'Exceso asignado' }}
          </span>
        </div>
      </div>

      <div class="mt-4 space-y-2">
        <div class="flex items-center justify-between text-xs text-gray-500">
          <span>Progreso: {{ plans.length }} cuotas</span>
          <span>{{ Math.min(Math.round((totalAssignedAmount / remainingBalance) * 100), 100) || 0 }}%</span>
        </div>
        <div class="h-2 w-full overflow-hidden rounded-full bg-gray-100">
          <div class="h-2 transition-all"
               [ngClass]="{
                 'bg-gray-900': (totalAssignedAmount / remainingBalance) <= 1,
                 'bg-rose-500': (totalAssignedAmount / remainingBalance) > 1
               }"
               [style.width.%]="Math.min(Math.round((totalAssignedAmount / remainingBalance) * 100), 100) || 0">
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-xl border border-gray-200 bg-gray-50 p-6">
      <div class="flex items-start gap-3">
        <div class="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-500 ring-1 ring-gray-200">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
          </svg>
        </div>
        <div class="space-y-2 text-sm text-gray-600">
          <p><span class="font-semibold text-gray-900">Campos editables:</span> Fecha de vencimiento, valor a pagar y observaciones.</p>
          <p><span class="font-semibold text-gray-900">Solo lectura:</span> Estado del pago y tipo de pagador.</p>
          <div class="rounded-lg border border-gray-200 bg-white p-3 text-xs text-gray-600">
            <span class="font-semibold text-gray-900">Participante individual:</span> Las cuotas empresariales se administran por separado.
          </div>
        </div>
      </div>
    </div>

    <!-- 🆕 Cuotas PAGADAS -->
    <div *ngIf="paidInstallments.length > 0" class="rounded-xl border border-emerald-200 bg-emerald-50/40 p-6">
      <button type="button" (click)="togglePaidSection()" class="flex w-full items-center justify-between gap-3 text-left">
        <h5 class="text-base font-semibold text-emerald-900">Cuotas ya pagadas ({{ paidInstallments.length }})</h5>
        <svg class="h-5 w-5 text-emerald-700 transition-transform" [class.rotate-180]="showPaidSection" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
      </button>
      <div *ngIf="showPaidSection" class="mt-4 space-y-3">
        <div *ngFor="let p of paidInstallments" class="rounded-lg border border-emerald-200 bg-white p-4">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div class="flex items-center gap-2">
                <span class="text-sm font-semibold text-gray-900">Cuota #{{ p.installmentNumber }}</span>
                <span class="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold text-emerald-700">PAGADA</span>
              </div>
              <div class="mt-1 text-xs text-gray-500">Vence {{ p.dueDate | date:'dd/MM/yyyy' }} · {{ p.amountToPay | currency:'COP':'symbol-narrow':'1.0-2' }}</div>
            </div>
            <div class="text-right">
              <div class="text-xs uppercase tracking-wide text-emerald-700">Pagado</div>
              <div class="text-sm font-semibold text-emerald-700">{{ p.amountPaid | currency:'COP':'symbol-narrow':'1.0-2' }}</div>
            </div>
          </div>
          <div *ngIf="p.amountPaid - p.amountToPay > 0.01" role="status"
            class="mt-3 flex items-center gap-2"
            style="background: #FFFBEB; border: 1px solid #FCD34D; border-radius: 8px; padding: 8px 12px;">
            <svg class="h-4 w-4 shrink-0" style="color: #D97706;" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            <span style="font-size: 13px; font-weight: 500; color: #92400E;">
              Sobrepago de {{ p.amountPaid - p.amountToPay | currency:'COP':'symbol-narrow':'1.0-2' }} → se generará un excedente al guardar
            </span>
          </div>
          <ul *ngIf="p.receipts?.length > 0" class="mt-2 space-y-1 text-xs text-gray-600 border-t border-emerald-100 pt-2">
            <li *ngFor="let r of p.receipts" class="flex justify-between gap-2">
              <span>{{ r.transactionDate | date:'dd/MM/yyyy' }} · {{ r.paymentMethodName || '—' }}</span>
              <span class="font-medium">{{ r.grossAmount | currency:'COP':'symbol-narrow':'1.0-2' }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 🆕 Cuotas PARCIALES -->
    <div *ngIf="partialInstallments.length > 0" class="rounded-xl border border-amber-300 bg-amber-50/40 p-6">
      <button type="button" (click)="togglePartialSection()" class="flex w-full items-center justify-between gap-3 text-left">
        <h5 class="text-base font-semibold text-amber-900">Cuotas parcialmente pagadas ({{ partialInstallments.length }})</h5>
        <svg class="h-5 w-5 text-amber-700 transition-transform" [class.rotate-180]="showPartialSection" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
      </button>
      <div *ngIf="showPartialSection" class="mt-4 space-y-3">
        <div *ngFor="let p of partialInstallments" class="rounded-lg border border-amber-200 bg-white p-4">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div class="flex items-center gap-2">
                <span class="text-sm font-semibold text-gray-900">Cuota #{{ p.installmentNumber }}</span>
                <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-800">PARCIAL</span>
              </div>
              <div class="mt-1 text-xs text-gray-500">Vence {{ p.dueDate | date:'dd/MM/yyyy' }} · Original {{ p.amountToPay | currency:'COP':'symbol-narrow':'1.0-2' }}</div>
            </div>
            <div class="text-right">
              <div class="text-xs uppercase tracking-wide text-amber-700">Pagado / Saldo</div>
              <div class="text-sm font-semibold text-amber-800">{{ p.amountPaid | currency:'COP':'symbol-narrow':'1.0-2' }} / <span class="text-rose-600">{{ (p.amountToPay - p.amountPaid) | currency:'COP':'symbol-narrow':'1.0-2' }}</span></div>
            </div>
          </div>
          <ul *ngIf="p.receipts?.length > 0" class="mt-2 space-y-1 text-xs text-gray-600 border-t border-amber-100 pt-2">
            <li *ngFor="let r of p.receipts" class="flex justify-between gap-2">
              <span>{{ r.transactionDate | date:'dd/MM/yyyy' }} · {{ r.paymentMethodName || '—' }}</span>
              <span class="font-medium">{{ r.grossAmount | currency:'COP':'symbol-narrow':'1.0-2' }}</span>
            </li>
          </ul>
          <div class="mt-4 space-y-2 border-t border-amber-100 pt-3">
            <p class="text-xs font-semibold text-amber-900">¿Qué hacés con esta cuota?</p>
            <label class="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
              <input type="radio" name="partial-{{p.id}}" class="mt-1" [checked]="partialActions[p.id] === 'keep'" (change)="applyPartialAction(p, 'keep')">
              <span><span class="font-medium">Mantener como está</span><span class="block text-xs text-gray-500">El saldo sigue debido en esta cuota.</span></span>
            </label>
            <label class="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
              <input type="radio" name="partial-{{p.id}}" class="mt-1" [checked]="partialActions[p.id] === 'close-redistribute'" (change)="applyPartialAction(p, 'close-redistribute')">
              <span><span class="font-medium text-amber-900">Cerrar y redistribuir saldo</span><span class="block text-xs text-gray-500">Cuota pasa a PAGADA; saldo prorrateado en pendientes posteriores.</span></span>
            </label>
            <label class="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
              <input type="radio" name="partial-{{p.id}}" class="mt-1" [checked]="partialActions[p.id] === 'close-loss'" (change)="applyPartialAction(p, 'close-loss')">
              <span><span class="font-medium text-rose-700">Cerrar y descontar del total</span><span class="block text-xs text-gray-500">Cuota pasa a PAGADA; saldo no cobrable, descontado del total.</span></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="redistributionLogLines.length > 0" class="rounded-xl border border-indigo-200 bg-indigo-50 p-4 text-xs text-indigo-900">
      <div class="font-semibold">Registro de redistribución de saldo</div>
      <ul class="mt-2 list-disc pl-5 space-y-1">
        <li *ngFor="let line of redistributionLogLines">{{ line }}</li>
      </ul>
    </div>

    <div class="rounded-xl border border-gray-200 bg-white p-6">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h5 class="text-base font-semibold text-gray-900">Cuotas del participante</h5>
        <button type="button"
                (click)="addPlan()"
                [disabled]="exceedsTotalAmount"
                class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-400">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd"></path>
          </svg>
          Agregar cuota
        </button>
      </div>

      <div formArrayName="plans" class="mt-6 space-y-4">
        <!-- 🆕 Vista ordenada asc + trackBy para no perder foco. -->
        <div *ngFor="let item of sortedPlansWithIndex; trackBy: trackByIdx"
             [formGroupName]="item.idx"
             class="rounded-lg border border-gray-200 bg-gray-50 p-4 sm:p-5">
          <div class="flex items-center justify-between gap-4">
            <h6 class="text-sm font-semibold text-gray-900">Cuota #{{ item.ctrl.get('installmentNumber')?.value }} · Participante</h6>
            <div class="flex items-center gap-2">
              <!-- 🆕 Recalcular cuotas siguientes con el saldo restante -->
              <button type="button"
                      *ngIf="item.ctrl.get('paymentStatus')?.value !== 'PAID' && item.ctrl.get('paymentStatus')?.value !== 'PARTIALLY_PAID'"
                      (click)="recalculateFromInstallment(item.idx)"
                      title="Distribuye el saldo restante entre las cuotas posteriores editables."
                      class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium text-gray-600 transition hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-700">
                <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 10h10l-3-3m3 3l-3 3M21 14H11l3 3m-3-3l3-3"/>
                </svg>
                Recalcular siguientes
              </button>
              <button type="button"
                      (click)="removePlan(item.idx)"
                      title="Eliminar esta cuota del plan"
                      class="rounded-full p-2 text-gray-400 transition hover:text-rose-500">
                <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>

          <div class="mt-4 grid gap-4 md:grid-cols-3">
            <div class="space-y-2">
              <label class="text-xs font-medium uppercase tracking-wide text-gray-500">Fecha de vencimiento</label>
              <p-calendar formControlName="dueDate" class="w-full calendar-field"></p-calendar>
            </div>
            <div class="space-y-2">
              <label class="text-xs font-medium uppercase tracking-wide text-gray-500">Valor a pagar</label>
              <input type="text"
                     formControlName="amountToPay"
                     appCurrencyFormatter
                     class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                     placeholder="0"/>
            </div>
            <div class="space-y-2">
              <label class="text-xs font-medium uppercase tracking-wide text-gray-500">Estado</label>
              <div class="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-600">
                <span *ngIf="item.ctrl.get('paymentStatus')?.value === 'PENDING'" class="flex items-center gap-2">
                  <span class="h-2 w-2 rounded-full bg-amber-500"></span>
                  Pendiente
                </span>
                <span *ngIf="item.ctrl.get('paymentStatus')?.value === 'PAID'" class="flex items-center gap-2">
                  <span class="h-2 w-2 rounded-full bg-emerald-500"></span>
                  Pagado
                </span>
                <span *ngIf="item.ctrl.get('paymentStatus')?.value === 'CANCELED'" class="flex items-center gap-2">
                  <span class="h-2 w-2 rounded-full bg-rose-500"></span>
                  Cancelado
                </span>
              </div>
            </div>
            <div class="md:col-span-3 space-y-2">
              <label class="text-xs font-medium uppercase tracking-wide text-gray-500">Observaciones</label>
              <textarea
                formControlName="observations"
                rows="2"
                class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                placeholder="Notas adicionales"></textarea>
            </div>
          </div>

          <div class="mt-4 grid gap-4 border-t border-gray-200 pt-4 text-xs uppercase tracking-wide text-gray-400 sm:grid-cols-2">
            <div><span class="text-gray-500">Tipo de pagador</span> <span class="ml-2 text-gray-900">Participante</span></div>
            <div><span class="text-gray-500">Número de cuota</span> <span class="ml-2 text-gray-900">{{ item.ctrl.get('installmentNumber')?.value }}</span></div>
          </div>
        </div>

        <div *ngIf="plans.length === 0"
             class="rounded-lg border border-dashed border-gray-200 bg-white py-10 text-center text-sm text-gray-500">
          <p class="font-medium text-gray-700">Sin cuotas configuradas</p>
          <p class="mt-2">Use el botón "Refinanciar cuotas" para generar el plan individual automáticamente.</p>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4 border-t border-gray-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
      <div class="text-sm text-gray-500">
        <span *ngIf="form.valid && isExactMatch" class="inline-flex items-center gap-2 text-emerald-600">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
          </svg>
          Listo para guardar
        </span>
        <span *ngIf="overpaymentPreview.count > 0" class="ml-3 inline-block" style="font-size: 13px; color: #92400E;">
          Se generará excedente por {{ overpaymentPreview.total | currency:'COP':'symbol-narrow':'1.0-2' }} en {{ overpaymentPreview.count }} cuota(s)
        </span>
        <span *ngIf="!form.valid" class="inline-flex items-center gap-2 text-rose-600">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
          </svg>
          Formulario incompleto
        </span>
        <span *ngIf="form.valid && !isExactMatch" class="inline-flex items-center gap-2 text-amber-600">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
          </svg>
          Debe coincidir con el saldo restante
        </span>
      </div>

      <div class="flex flex-col gap-3 sm:flex-row">
        <button type="button"
                (click)="showRefinanceModal = true"
                [disabled]="plans.length === 0"
                class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"></path>
          </svg>
          Refinanciar cuotas
        </button>
        <button type="submit"
                [disabled]="form.invalid || !isExactMatch"
                class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-900 px-6 py-2 text-sm font-semibold text-white transition hover:bg-gray-800">
          <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
          </svg>
          Guardar cambios
        </button>
      </div>
    </div>
  </form>

  <div *ngIf="showRefinanceModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/60 p-4">
    <div class="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-2xl">
      <div class="flex items-start justify-between">
        <div>
          <h2 class="text-lg font-semibold text-gray-900">Refinanciar plan del participante</h2>
          <p class="mt-1 text-sm text-gray-500">Distribuya nuevamente el saldo pendiente en cuotas consecutivas.</p>
        </div>
        <button (click)="closeRefinanceModal()"
                class="rounded-full p-2 text-gray-400 transition hover:text-gray-600">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="mt-6 space-y-6">
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Saldo a refinanciar</p>
          <p class="mt-2 text-2xl font-semibold text-gray-900">{{ remainingBalance | currency:'COP' }}</p>
          <p class="mt-1 text-sm text-gray-600">Este monto se distribuirá automáticamente en las cuotas del participante.</p>
        </div>

        <div class="space-y-3">
          <label class="text-sm font-semibold text-gray-900">¿En cuántas cuotas desea refinanciar?</label>
          <div class="flex items-center gap-4">
            <button type="button"
                    (click)="refinanceInstallments = Math.max(minInstallments, refinanceInstallments - 1)"
                    [disabled]="refinanceInstallments <= minInstallments"
                    class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-base font-semibold text-gray-700 transition hover:bg-gray-100 disabled:opacity-60">
              −
            </button>
            <div class="text-center">
              <input type="number"
                     [(ngModel)]="refinanceInstallments"
                     [min]="minInstallments"
                     [max]="maxInstallments"
                     class="w-24 rounded-lg border border-gray-200 bg-white py-2 text-center text-xl font-semibold text-gray-900 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200">
              <div class="mt-1 text-xs text-gray-500">Cuotas</div>
            </div>
            <button type="button"
                    (click)="refinanceInstallments = Math.min(maxInstallments, refinanceInstallments + 1)"
                    [disabled]="refinanceInstallments >= maxInstallments"
                    class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-base font-semibold text-gray-700 transition hover:bg-gray-100 disabled:opacity-60">
              +
            </button>
          </div>
          <p class="text-center text-xs text-gray-500">Rango permitido: {{ minInstallments }} - {{ maxInstallments }} cuotas</p>
        </div>

        <div class="rounded-lg border border-gray-200 bg-white p-4">
          <div class="flex items-center justify-between text-sm text-gray-600">
            <span>Estimado por cuota</span>
            <span class="text-lg font-semibold text-gray-900">{{ getEstimatedInstallmentAmount() | currency:'COP' }}</span>
          </div>
          <p class="mt-2 text-xs text-gray-500">La última cuota puede variar ligeramente para ajustar diferencias de redondeo.</p>
        </div>

        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
          <span class="font-semibold text-gray-900">Importante:</span> Se reemplazan las cuotas actuales del participante por un nuevo plan con fechas mensuales consecutivas.
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row">
        <button type="button"
                (click)="closeRefinanceModal()"
                class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
          Cancelar
        </button>
        <button type="button"
                (click)="confirmRefinance()"
                [disabled]="!isValidRefinanceRange()"
                class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-900 bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400">
          Confirmar refinanciación
        </button>
      </div>
    </div>
  </div>
</div>

  <!-- 🆕 Modal: crear cuota para absorber saldo sin cuotas posteriores -->
  <div *ngIf="showCreateInstallmentModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/60 p-4">
    <div class="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-2xl">
      <h2 class="text-lg font-semibold text-gray-900">No hay cuotas posteriores</h2>
      <p class="mt-1 text-sm text-gray-500">
        Esta cuota no tiene cuotas pendientes posteriores donde repartir el saldo.
        ¿Crear una cuota nueva que absorba el saldo restante?
      </p>

      <div class="mt-6 space-y-4">
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Saldo a absorber</p>
          <p class="mt-1 text-lg font-semibold text-gray-900">{{ pendingShortfall | currency:'COP' }}</p>
        </div>
        <div>
          <label class="text-sm font-semibold text-gray-900">Fecha de vencimiento de la cuota nueva</label>
          <input type="date" [(ngModel)]="newInstallmentDate"
                 class="mt-2 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-gray-900 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200" />
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row">
        <button type="button" (click)="cancelCreateInstallment()"
                class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
          Cancelar (mantener cuota)
        </button>
        <button type="button" (click)="confirmCreateInstallment()"
                [disabled]="!newInstallmentDate"
                class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-900 bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400">
          Crear cuota
        </button>
      </div>
    </div>
  </div>

<!-- 🆕 Modal Motivo + comentario obligatorio (versionado por grupo) -->
<div *ngIf="showReasonModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
    <h2 class="text-xl font-bold text-gray-900">Motivo del cambio</h2>
    <p class="mt-1 text-sm text-gray-600">
      Estás creando una <strong>nueva versión</strong> del plan del participante. Para auditoría debe quedar registrado por qué.
    </p>
    <div class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">Categoría</label>
      <select [(ngModel)]="selectedReason"
        class="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm">
        <option *ngFor="let r of reasonChoices" [ngValue]="r.value">{{ r.label }}</option>
      </select>
    </div>
    <div class="mt-4">
      <label class="block text-sm font-semibold text-gray-800">Comentario (obligatorio)</label>
      <textarea [(ngModel)]="reasonComment" rows="3" maxlength="2000"
        placeholder="Ej: Cliente solicitó aplazar cuotas restantes 30 días."
        class="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"></textarea>
      <p class="mt-1 text-xs text-gray-500">{{ reasonComment.length }} / 2000</p>
    </div>
    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeReasonModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmReasonAndSave()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-900 bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-800">
        Guardar nueva versión
      </button>
    </div>
  </div>
</div>

<app-excess-summary-modal *ngIf="excessSummary.length > 0" [items]="excessSummary" (closed)="onExcessSummaryClosed()"></app-excess-summary-modal>
